module.exports = __webpack_public_path__ + "ui-static/img/hooks-filter-default_dark.c24ce954.svg";